<div class="mock-page">
  <div class="mock-message">
    <p class="mock-text">NGS page.</p>
  </div>
</div>
